import * as React from 'react'
import { DateRangeSelector, DateRangeValueType } from 'shared/components/DateRangeSelector/DateRangeSelector'
import { Handler, HandlerOf } from 'shared/helpers/typeHelper'
import { SafetyEventCategory } from 'shared/models/compliance'

import {
  SafetyEventFiltersTypes,
  SelectedSafetyEventFiltersType,
  SelectedSafetyEventFiltersValuesType,
} from './SafetyEventsFilters.constants'
import { SafetyEventFiltersSelector } from './SafetyEventsFilterSelector'

interface SafetyEventFiltersOptionProps {
  filterType: SafetyEventFiltersTypes
  label: string
  selectedFilters: SelectedSafetyEventFiltersType
  setSelectedFilters: HandlerOf<SelectedSafetyEventFiltersType>
  selectedFiltersValues: SelectedSafetyEventFiltersValuesType
  setSelectedFiltersValues: HandlerOf<SelectedSafetyEventFiltersValuesType>
  selectedDateRangeValue: DateRangeValueType
  setSelectedDateRangeValue: (nextRange: DateRangeValueType, done: boolean) => void
  opener?: React.ReactNode
  isInitiallyOpen?: boolean
  onBlur?: Handler
}

export function SafetyEventFiltersOption({
  filterType,
  label,
  selectedFilters,
  setSelectedFilters,
  selectedFiltersValues,
  setSelectedFiltersValues,
  selectedDateRangeValue,
  setSelectedDateRangeValue,
  opener,
  isInitiallyOpen,
  onBlur,
}: SafetyEventFiltersOptionProps) {
  if (filterType === SafetyEventFiltersTypes.DATE) {
    return (
      <DateRangeSelector
        key={filterType}
        selected={selectedFilters[filterType]}
        deselect={() => {
          setSelectedFilters({ ...selectedFilters, [SafetyEventFiltersTypes.DATE]: false })
          setSelectedDateRangeValue([undefined, undefined], true)
        }}
        label={label}
        selectedDateRange={selectedDateRangeValue}
        setSelectedDateRange={(nextRange, done) => {
          setSelectedDateRangeValue(nextRange, done)
        }}
        opener={opener}
        isInitiallyOpen={isInitiallyOpen}
        onBlur={onBlur}
        width="280px"
      />
    )
  }

  return (
    <SafetyEventFiltersSelector
      key={filterType}
      selected={selectedFilters[filterType]}
      deselect={() => {
        setSelectedFilters({ ...selectedFilters, [filterType]: false })
        setSelectedFiltersValues({ ...selectedFiltersValues, [filterType]: 'ALL' })
      }}
      label={label}
      options={[
        { label: 'Driving behavior', value: SafetyEventCategory.DRIVING_BEHAVIORS },
        { label: 'Accidents & violations', value: SafetyEventCategory.ACCIDENTS_AND_VIOLATIONS },
        { label: 'Compliance', value: SafetyEventCategory.COMPLIANCE },
      ]}
      selectedValue={selectedFiltersValues[filterType]}
      setSelectedValue={(nextSelectedValue) =>
        setSelectedFiltersValues({
          ...selectedFiltersValues,
          [filterType]: nextSelectedValue,
        })
      }
      opener={opener}
      isInitiallyOpen={isInitiallyOpen}
      onBlur={onBlur}
    />
  )
}
